import { ReactNode, createContext, useEffect, useState } from 'react'
import sheetsApi from 'g-sheets-api'

type ContestantScore = {
    reach: number
    engagement: number
}

type ContestantScoreContextType = {
    getScoreById: (_: string) => ContestantScore
}
export const ContestantScoreContext = createContext<ContestantScoreContextType>({
    getScoreById: () => ({ reach: 0, engagement: 0 })
})

type Props = {
    children: ReactNode
}
export default function ContestantScoreContextProvier({ children }: Props) {
    const [data, setData] = useState<{
        contestantScores: { [key: string]: ContestantScore }
        contestantIds: string[]
    }>({
        contestantScores: {},
        contestantIds: []
    })

    useEffect(() => {
        sheetsApi(
            {
                sheetId: '1-tpxSXoKFVodkozHHH9zr_qOUVnZbVCV2eMsDzKGyrw',
                returnAllResults: false,
                apiKey: 'AIzaSyDtO99neDQtQGM9PVEJC0A8EkZAd9YR6kY',
                sheetName: 'METRICS'
            },
            (data: any) => {
                const contestantScores: { [key: string]: ContestantScore } = {}
                const contestantIds: string[] = []
                data.forEach((item: any) => {
                    const contestantId = item['SBD']
                    contestantIds.push(contestantId)
                    contestantScores[contestantId] = {
                        reach: item['PEOPLE REACHED'],
                        engagement: item['POST ENGAGEMENT']
                    }
                })
                setData({ contestantScores, contestantIds })
            },
            (error: any) => {
                console.log(error)
            }
        )
    }, [])

    function getScoreById(contestantId: string): ContestantScore {
        return data.contestantScores[contestantId]
    }

    return <ContestantScoreContext.Provider value={{ getScoreById }}>{children}</ContestantScoreContext.Provider>
}
